import { Box, Modal, Typography } from '@mui/material';
import { NotificationText } from '@/data/context/notifications';
import ClearIcon from '@mui/icons-material/Clear';
import { DpBaseButton } from '@/components/blocks/DpBaseButton';
import {
	NotificationsModalButtonSX,
	NotificationsModalContentSX,
	NotificationsModalFrameSX,
	NotificationsModalHeaderFrameSX,
	NotificationsModalHeaderIconSX,
	NotificationsModalMessageSX,
	NotificationsModalTitleSX,
} from '@/components/content/Notifications/styles/modal';
import { ZIndex } from '@/utils/zIndex';

interface NotificationModalProps {
	id: string;
	title?: NotificationText;
	message?: NotificationText;
	mobile: boolean;
	onClear: () => void;
}

export const NotificationModal: React.FC<NotificationModalProps> = ({
	id,
	title,
	message,
	mobile,
	onClear,
}) => (
	<Modal
		open={message ? true : false}
		aria-labelledby={id}
		aria-describedby={`${id}-description`}
		slotProps={{
			root: {
				sx: { zIndex: ZIndex.HIGHEST },
			} as any,
		}}
		onClose={onClear}
	>
		<Box sx={NotificationsModalFrameSX(mobile)}>
			<Box sx={NotificationsModalHeaderFrameSX(mobile)}>
				<ClearIcon sx={NotificationsModalHeaderIconSX} onClick={onClear} />
			</Box>
			<Box sx={NotificationsModalContentSX(mobile)}>
				{title ? (
					<Typography id={id} sx={NotificationsModalTitleSX(mobile)}>
						{title}
					</Typography>
				) : null}
				<Typography id={`${id}-description`} sx={NotificationsModalMessageSX}>
					{message}
				</Typography>
				<DpBaseButton sx={NotificationsModalButtonSX} onClick={onClear}>
					{'Aceptar'}
				</DpBaseButton>
			</Box>
		</Box>
	</Modal>
);
